import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Resetpassword from "../pages/Resetpassword";
import Resetpasswordlink from "../pages/Resetpasswordlink";
import Signin from "../pages/Signin";
import Signup from "../pages/Signup";
import Notfound from "./Notfound";
import Signint from "../pages/technition/Signint";
import Signinclient from "../pages/client/Signinclient";
import Airconview from "../pages/Airconview";

const Homelayout = () => {
  useEffect(() => {
    /*  setHeaderheight(ref.current.clientHeight) */
  });
  return (
    <div className="home-layout-container">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signin" element={<Signin />} />
        <Route path="/signint" element={<Signint />} />
        <Route path="/signinc" element={<Signinclient />} />
        <Route path="/airconview" element={<Airconview />} />

        <Route path="/signup" 
        element={<Signup />} />
        <Route path="/resetpassword" element={<Resetpassword />} />
        <Route path="/resetlink" element={<Resetpasswordlink />} />
        <Route path="*" element={<Notfound />} />
      </Routes>
    </div>
  );
};

export default Homelayout;
